
import { IOC } from '@/ioc/index';
import { defaultLocale } from '@/src/shared/utils/i18n';
import { serialize } from '@/src/shared/utils/serialization';

import { createEmptyLayout } from '../../domain/models/cms-layout';
import { CMSLayoutViewModel } from '../view-models/content/cms-layout.viewModel';

import type { CacheHeadersBuilder } from '@/src/shared/domain/models/cache-headers-builder';
import type {
  CreateSsrDataOptions,
  SsrDataFactory
} from '@/src/shared/presentation/ssr/ssr-data-factory';
import type { AppLocale } from '@/src/shared/utils/i18n';
import type { JsonObject } from '@/src/shared/utils/serialization.types';


export class CmsLayoutSSRFactory implements SsrDataFactory<CMSLayoutViewModel> {
  key = CmsLayoutSSRFactory.getKey();

  constructor(
    private readonly language: AppLocale = defaultLocale,
    private readonly cacheHeadersBuilder: CacheHeadersBuilder | null = null
  ) { }

  async create({ logAndSaveError }: CreateSsrDataOptions) {
    try {
      const useCase = await IOC.gather('GetBaseLayoutMenus_UseCase');
      const menus = await useCase.execute(this.language, this.cacheHeadersBuilder);
      const viewModel = CMSLayoutViewModel.presenter(menus);

      return viewModel;
    } catch (e) {
      logAndSaveError(this.key, e);
      return CMSLayoutViewModel.presenter(createEmptyLayout());
    }
  }

  serialize(data: CMSLayoutViewModel) {
    return serialize(data);
  }

  deserialize(serialized: JsonObject) {
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return serialized && CMSLayoutViewModel.presenter(serialized as any);
  }

  static getKey = () => 'cmsMenus';
}
